/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React from 'react';
import { NavLink } from 'react-router-dom';
import ParticleBackground from '../elements/ParticleBackground';

export default function Hero() {
  return (
    <section className="hero-neon hero-centered relative min-h-screen flex items-center justify-center overflow-hidden">
      <ParticleBackground />

      <div className="container mx-auto px-4 lg:px-8 z-10">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="hero-punchline">
            Building the Future
            {' '}
            <span className="neon-text">Beyond Web3</span>
          </h1>

          <p className="hero-subline">
            Custom software, AI systems, and scalable digital products for ambitious brands.
          </p>

          <div className="hero-cta-wrap">
            <NavLink to="/contact" className="hero-cta-primary">
              Talk to An AI Expert
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </NavLink>
          </div>
        </div>
      </div>
    </section>
  );
}
